import { Typography, Button, CircularProgress } from '@mui/material';
import { LivestreamViewModel } from './useLivestream.viewModel';
import livestreamingFullImage from '/static/images/livestreaming_full.png';

type EnableLivestreamProps = Pick<
  LivestreamViewModel,
  'submitting' | 'dispatch'
>;

export const EnableLivestream = ({
  submitting,
  dispatch,
}: EnableLivestreamProps) => {
  return (
    <div className="h-[80vh] bg-white rounded-[20px] flex flex-col justify-center items-center gap-6 p-12">
      <img src={livestreamingFullImage} className="max-w-[265px]" />
      <div className="flex flex-col justify-center items-center gap-4">
        <Typography sx={{ fontSize: 36, fontWeight: 700, lineHeight: '44px' }}>
          Ready for livestreaming?
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            textAlign: 'center',
          }}
        >
          Live stream is a great way to engage with and retain subscribers as
          well as build relationships.
        </Typography>
      </div>
      <Button
        variant="contained"
        onClick={() => dispatch({ type: 'submitEnable' })}
        disabled={submitting}
        sx={{
          width: '340px',
        }}
      >
        {submitting ? (
          <CircularProgress className="h-[20px] w-[20px]" />
        ) : (
          'Enable Live Streaming'
        )}
      </Button>
    </div>
  );
};
